<h6 mat-dialog-title><span [innerHTML]="title" class="[ headline-small ][ on-surface ]"></span></h6>
@if (message) {
  <div mat-dialog-content>
    <p [class]="messageClass" data-cy="cm-content" [innerHTML]="message"></p>
  </div>
}
<dcr-text-field [pattern]="pattern" [formControl]="inputControl" [label]="inputLabel" [placeholder]="placeholder" required></dcr-text-field>
<div mat-dialog-actions class="[ cluster justify-end ]">
  <div>
    @if (cancelType === 'default') {
      <dcr-outline-button
        [label]="cancelLabel"
        data-cy="cm-cancel"
        (click)="cancel()"
      ></dcr-outline-button>
    }
    @if (cancelType === 'inline') {
      <dcr-inline-button
        [label]="cancelLabel"
        data-cy="cm-cancel"
        (click)="cancel()"
      ></dcr-inline-button>
    }

    @if (confirmType === 'default') {
      <dcr-outline-button
        campusClickStopPropagation
        [label]="confirmLabel"
        [leadingIcon]="this.confirmIcon"
        [disabled]="disableConfirm || inputControl.invalid"
        data-cy="cm-confirm"
        (click)="confirm()"
      ></dcr-outline-button>
    }
    @if (confirmType === 'primary') {
      <dcr-filled-button
        campusClickStopPropagation
        [label]="confirmLabel"
        [leadingIcon]="this.confirmIcon"
        [disabled]="disableConfirm || inputControl.invalid"
        data-cy="cm-confirm"
        (click)="confirm()"
      ></dcr-filled-button>
    }
    @if (confirmType === 'danger') {
      <dcr-tonal-button
        campusClickStopPropagation
        color="stage/error"
        [label]="confirmLabel"
        [leadingIcon]="this.confirmIcon"
        [disabled]="disableConfirm || inputControl.invalid"
        data-cy="cm-confirm"
        (click)="confirm()"
      ></dcr-tonal-button>
    }
  </div>
</div>
